module.exports = __webpack_public_path__ + "img/aa857bd.svg";